import { createFileRoute, Link } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { LayoutGrid, ShieldCheck, Clock } from "lucide-react";
import { api } from "@/lib/api";
import { Badge, Card, Spinner } from "@/components/ui/primitives";

export const Route = createFileRoute("/queue")({ component: QueuePage });

function QueuePage() {
  const { data, isLoading } = useQuery({
    queryKey: ["applications", "in_progress"],
    queryFn: () => api.listApplications("in_progress", ""),
  });
  if (isLoading) return <div className="flex items-center gap-2 text-muted-foreground"><Spinner /> Loading queue…</div>;

  const pending = (data?.items ?? []).filter((a) => a.status === "pending_review" || a.status === "needs_info");

  return (
    <div className="space-y-6">
      <header>
        <h1 className="flex items-center gap-2 text-3xl font-semibold tracking-tight">
          <LayoutGrid className="h-7 w-7 text-brand" strokeWidth={1.7} /> Review Queue
        </h1>
        <p className="mt-1 text-sm text-muted-foreground">Applications awaiting officer action.</p>
      </header>
      <Card>
        <ul className="divide-y divide-border">
          {pending.length === 0 && <li className="p-6 text-sm text-muted-foreground">The queue is empty.</li>}
          {pending.map((a) => (
            <li key={a.id}>
              <Link to="/apps/$id/decision" params={{ id: a.id }} className="flex items-center gap-4 p-4 hover:bg-muted/30 transition-colors">
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <span className="font-medium">{a.customer_name}</span>
                    <Badge variant="muted">{a.product_label}</Badge>
                    {a.risk_tier && <Badge variant="default">Tier {a.risk_tier}</Badge>}
                    {a.status === "needs_info" ? (
                      <Badge variant="warn">Needs info</Badge>
                    ) : (
                      <Badge variant="warn">
                        <ShieldCheck className="h-3 w-3" strokeWidth={2.2} />
                        Pending review
                      </Badge>
                    )}
                  </div>
                  <div className="mt-1 text-sm text-muted-foreground">
                    {a.amount_display} · submitted {a.submitted_ago}
                  </div>
                </div>
                <div className="flex items-center gap-1 text-xs text-muted-foreground">
                  <Clock className="h-3.5 w-3.5" strokeWidth={1.8} />
                  {a.submitted_ago}
                </div>
              </Link>
            </li>
          ))}
        </ul>
      </Card>
    </div>
  );
}
